import { motion } from "framer-motion";
import { Price } from "./Price";
import { APP } from "../../constants/testIds";

export const ProductCard = ({ item, index = 0 }) => {
  const hasSinglePrice = typeof item.price === "number";
  const hasVariants = Array.isArray(item.variants) && item.variants.length > 0;

  return (
    <motion.article
      data-testid={APP.productCard(item.id)}
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1],
        delay: Math.min(index * 0.04, 0.24),
      }}
      className="group relative border-b border-[#c9a961]/12 py-6 first:pt-2 last:border-b-0 sm:py-7 md:hover:bg-[#c9a961]/[0.02] md:transition-colors"
    >
      <div className="flex items-start justify-between gap-5 sm:gap-8">
        <div className="min-w-0 flex-1">
          <h3 className="font-playfair text-lg leading-snug text-[#f4e9d5] sm:text-xl md:text-2xl">
            {item.name}
            {item.subtitle && (
              <span className="ml-2 font-inter text-xs uppercase tracking-[0.2em] text-[#f4e9d5]/45 sm:text-[11px]">
                — {item.subtitle}
              </span>
            )}
          </h3>

          {item.description && (
            <p className="mt-2 max-w-prose font-inter text-[13px] leading-relaxed text-[#f4e9d5]/60 sm:text-sm">
              {item.description}
            </p>
          )}

          {item.variantsInline && item.variantsInline.length > 0 && (
            <div className="mt-3 flex flex-wrap items-center gap-x-2 gap-y-1">
              {item.variantsLabel && (
                <span className="font-inter text-[10px] uppercase tracking-[0.24em] text-[#c9a961]/70">
                  {item.variantsLabel}:
                </span>
              )}
              {item.variantsInline.map((v, i) => (
                <span
                  key={v}
                  className="font-inter text-[11px] text-[#f4e9d5]/70 sm:text-xs"
                >
                  {v}
                  {i < item.variantsInline.length - 1 && (
                    <span className="ml-2 text-[#c9a961]/40">·</span>
                  )}
                </span>
              ))}
            </div>
          )}
        </div>

        {/* Price column — only shown here when there is a single price */}
        {hasSinglePrice && (
          <div className="shrink-0 pt-1">
            <Price
              amount={item.price}
              prefix={item.pricePrefix || ""}
              suffix={item.priceSuffix || ""}
            />
          </div>
        )}
      </div>

      {/* Variants block */}
      {hasVariants && (
        <div className="mt-4 flex flex-wrap gap-x-6 gap-y-2 border-l border-[#c9a961]/20 pl-4 sm:mt-5 sm:gap-x-10">
          {item.variants.map((v) => (
            <div
              key={v.label}
              className="flex items-baseline gap-3 whitespace-nowrap"
            >
              <span className="font-inter text-[11px] uppercase tracking-[0.22em] text-[#f4e9d5]/70 sm:text-xs">
                {v.label}
              </span>
              <span className="h-px flex-1 min-w-[14px] bg-[#c9a961]/20" />
              <Price amount={v.price} />
            </div>
          ))}
        </div>
      )}
    </motion.article>
  );
};
